import { DateForm } from "../../utils/medicalDocument/form";
import moment from "moment";

export default (props) => {
  const minDate = moment().subtract(6, "month");

  return <DateForm {...props} minDate={minDate} />;
};
